import React from "react";

function Loading({ loading = true }) {
  return (
    <div className={`modal ${loading ? "is-active" : ""}`}>
      <div className="modal-background" />
      <div className="modal-content">
        <div className="box">
          <span className="has-text-centered">Loading...</span>
          <progress className="progress" />
        </div>
      </div>
    </div>
  );
}

export default Loading;
